<template>
  <div class="container-fluid">
    <div class="row treasure_island_top_row">
      <div class="col-2"></div>
      <div class="col-3 cloud-l">
      </div>
      <div class="col-3 treasure_island_login">
      </div>
      <div class="col-2 cloud-r">
        <div class="col-2"></div>
      </div>
    </div>
    <div class="row login-page">
      <div class="col-lg-12">
        <div class="login-page--right whiteandround">
          <div class="login-form">
            <form action="">
              <div class="form_title">
                <h1>{{ getTranslations.visitor_sign_up_1_single_country_login }}</h1>
              </div>
              <div v-if="facebookFunctionality"
                   :class="['form-group form-group--icon fb_login ', !errorInFb ? '' : 'has-warning']">
                <facebook-login :enteredUsername="testUser"
                                :type="fbActionType"
                                @errorsUpdated="methodForEvent($event)">
                </facebook-login>
                <span v-if="errorInFb"
                      class="form-group__feedback">{{ getMessage(errorInFb) }}
                </span>
              </div>
              <div v-if="facebookFunctionality"
                   class="form-group form-group--or">
                <div>
                  <span>{{ getTranslations.visitor_sign_up_and_login_or }}</span>
                </div>
              </div>
              <div class="form-group form-group--icon">
                <input type="text"
                       v-model="user.username"
                       :placeholder="getTranslations.visitor_login_placeholder_enter_username"
                       class="username form-group__textfield"
                       @click.prevent="change" />
              </div>
              <div :class="['form-group', 'form-group--icon', !user.hasErrors ? '' : 'has-warning']">
                <input type="password"
                       v-model="user.password"
                       :class="['password form-group__textfield', !user.hasErrors ? 'has-success' : 'has-warning']"
                       :placeholder="getTranslations.visitor_login_placeholder_enter_password"
                       @click.prevent="change"/>
                <span v-show="getMessage(user.message)"
                      class="form-group__feedback">{{ getMessage(user.message) }}
                </span>
              </div>
              <div class="row login-bottom">
                <div class="col">
                  <div class="form-group form-group--checkbox">
                    <input id="remember_me"
                           type="checkbox"
                           v-model="rememberMeParameter">
                    <label for="remember_me">{{ getTranslations.visitor_login_remember_me }}</label>
                  </div>
                </div>
                <div class="col">
                  <div class="login-form__forgot-password">
                    <a style="cursor: pointer;" @click.prevent="showPinModal = true;">
                      <img class="info_icon" src="static/images/icon-info-XL.svg">
                      {{ getTranslations.visitor_login_what_my_pin }}
                    </a>
                    <router-link :to="'forgotPassword1'">{{ getTranslations.home_modals_change_login_pin_forgot }}</router-link>
                  </div>
                </div>
              </div>
              <input type="submit"
                     :value="getTranslations.visitor_sign_up_1_single_country_login"
                     :class="['btn btn--medium btn--main', ( user.hasErrors  ? 'deactivated' : '')]"
                     @click.prevent="checkButton">
              <p class="login_create_account">{{getTranslations.visitor_login_new_here}}
                <a style="cursor:pointer" @click.prevent="goToRegistration">{{ getTranslations.visitor_login_create_account }}</a>
              </p>
            </form>
          </div>
        </div>
      </div>
    </div>
    <login-modal v-if="showPinModal"
                 @close="showPinModal = false;">
    </login-modal>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapState } from 'vuex';
import IntegrationMixin from '@/common/mixins/integration';
import RegistrationFlowMixin from '@/common/mixins/flow';
import LoginModal from '@/components/home/modals/LoginModal';
import FacebookLogin from './FacebookLogin';

export default {
  components: { FacebookLogin, LoginModal },
  name: 'login',
  mixins: [IntegrationMixin, RegistrationFlowMixin],
  data() {
    return {
      showPinModal: false,
      testUser: 'User',
      fbActionType: 'login',
      errorInFb: null,
      rememberMeParameter: true,
      user: {
        username: '',
        password: '',
        message: '',
        hasErrors: false,
      },
    };
  },
  methods: {
    ...mapActions('i18n', [
      'updateUserLanguage',
    ]),
    ...mapActions('profile', [
      'getUserLoginDetails',
      'callForAuthorization',
    ]),
    goToRegistration() {
      this.registrationRedirect();
    },
    getMessage(key) {
      return this.getTranslations[key] || '';
    },
    methodForEvent(event) {
      this.errorInFb = event;
    },
    checkButton() {
      this.user.message = '';
      this.errorInFb = null;
      const userData = {
        username: this.user.username,
        password: this.user.password,
        rememberMe: this.rememberMeParameter,
      };
      this.callForAuthorization(userData).then(() => {
        if (this.getUserAuthorized) {
          this.getUserLoginDetails().then(() => {
            if (this.getUserAuthorized) {
              this.user.hasErrors = false;
              this.updateUserLanguage();
              this.$router.push('home');
            } else {
              this.user.message = 'visitor_login_server_error';
              this.user.hasErrors = true;
            }
          });
        } else {
          this.user.message = 'visitor_login_invalid_password';
          this.user.hasErrors = true;
          this.errorInFb = null;
        }
      });
    },
    change() {
      this.user.hasErrors = false;
      this.user.message = '';
      this.errorInFb = null;
    },
  },
  computed: {
    ...mapState('common', [
      'facebookFunctionality',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
    ...mapGetters('profile', [
      'getUserAuthorized',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/visitor/Login.vue